import { Flame } from "lucide-react";
import CONFIG from "../config";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="relative w-full mt-0 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 z-0" style={{
        backgroundImage: "url('/assets/hero-bg-4.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center top",
        opacity: 0.06,
      }} />
      <div className="absolute inset-0 z-[1] bg-gradient-to-t from-[#050404] via-[#050404]/95 to-transparent" />

      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-fire-red/30 to-transparent" />

      <div className="relative z-10 px-4 sm:px-6 md:px-12 lg:px-20 py-10 sm:py-14">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div className="flex items-center gap-3">
            <div className="p-2 border border-fire-dark/40 bg-fire-dark/15" style={{ borderRadius: "2px" }}>
              <Flame className="w-5 h-5 text-fire-red" />
            </div>
            <span className="font-cinzel text-lg font-bold uppercase tracking-[0.15em] text-foreground">{CONFIG.TOKEN_NAME}</span>
          </div>
          <div className="flex flex-wrap gap-8">
            <a data-testid="footer-twitter" href={CONFIG.TWITTER_URL} target="_blank" rel="noopener noreferrer" className="font-mono text-xs text-muted-foreground/60 hover:text-fire-red uppercase tracking-[0.15em] transition-colors duration-300">
              <i className="fa-brands fa-x-twitter mr-1.5" />Twitter
            </a>
            {/*<a data-testid="footer-telegram" href={CONFIG.TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className="font-mono text-xs text-muted-foreground/60 hover:text-fire-red uppercase tracking-[0.15em] transition-colors duration-300">
              <i className="fa-brands fa-telegram mr-1.5" />Telegram
            </a> */}
            <a data-testid="footer-dexscreener" href={`https://dexscreener.com/solana/${CONFIG.PAIR_ADDRESS}`} target="_blank" rel="noopener noreferrer" className="font-mono text-xs text-muted-foreground/60 hover:text-fire-red uppercase tracking-[0.15em] transition-colors duration-300">
              DexScreener
            </a>
            <a data-testid="footer-solscan" href={`https://solscan.io/token/${CONFIG.TOKEN_CA}`} target="_blank" rel="noopener noreferrer" className="font-mono text-xs text-muted-foreground/60 hover:text-fire-red uppercase tracking-[0.15em] transition-colors duration-300">
              Solscan
            </a>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-forge-steel/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-[10px] text-muted-foreground/40 uppercase tracking-[0.15em]">Year of the Fire Horse 2026 Chinese New Year</p>
          <p className="font-mono text-[10px] text-muted-foreground/25">{CONFIG.TOKEN_NAME} is a meme token. Not financial advice. DYOR.</p>
        </div>
      </div>
    </footer>
  );
};
